import Reveal from "@/components/Reveal";
import { overline } from "@/components/kit";

export default function PageHero({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <section className="relative border-b border-ink/10 bg-mist pt-36 pb-16 md:pt-44 md:pb-24" data-testid="page-hero">
      <div className={`mx-auto max-w-[1440px] px-5 md:px-10 ${align === "center" ? "text-center" : ""}`}>
        <Reveal>
          <span className={overline}>{eyebrow}</span>
        </Reveal>
        <Reveal delay={1}>
          <h1 className="mt-6 max-w-4xl font-serif text-5xl font-medium leading-[0.95] tracking-tight text-ink md:text-7xl lg:text-8xl">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={2}>
            <p className={`mt-7 max-w-2xl text-base leading-relaxed text-ink/60 md:text-lg ${align === "center" ? "mx-auto" : ""}`}>
              {subtitle}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
